import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import ToastUtil from "../../../../components/ToastNotification/ToastUtil";
import { newFetch, GET } from "../../../../helpers/fetch";
import docImg from "../../../../assets/icons/document.png";

const FeedbackLogs = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFeedbacks();
  }, []);

  const fetchFeedbacks = async () => {
    try {
      setLoading(true);
      const response = await newFetch(GET, "/associate/feedback/user");

      if (response.success) {
        setFeedbacks(response.data);
      } else {
        ToastUtil.error(response.message || t("Failed to fetch feedbacks"));
      }
    } catch (error) {
      console.error("Error fetching feedbacks:", error);
      ToastUtil.error(t("Failed to fetch feedbacks"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="table-responsive bg-white rounded shadow p-3">
      <div className="edit-button-wrapper mb-4 d-flex justify-content-between align-items-center">
        <button
          onClick={() => history.push("/communications/feedback/add")}
          className="btn btn-design btn-brand"
        >
          {t("Submit Feedback")}
        </button>
      </div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">{t("Submissions")}</h5>
      </div>

      <hr className="my-2" />

      <table className="table table-borderless mb-0">
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="3" className="text-center text-muted py-4">
                {t("Loading...")}
              </td>
            </tr>
          ) : feedbacks && feedbacks.length > 0 ? (
            feedbacks.map((feedback, index) => (
              <tr key={index} className="align-middle border-bottom">
                <td>
                  <button
                    className="btn btn-link p-0"
                    style={{
                      color: "#5156BE",
                    }}
                    onClick={() =>
                      history.push({
                        pathname: "/communications/feedback/view",
                        state: { feedback },
                      })
                    }
                  >
                    {feedback.feedback_id} - {feedback.title}
                  </button>
                  {feedback?.unread_count ? (
                    <span
                      className="badge badge-pill"
                      style={{
                        backgroundColor: "#dc3545",
                        color: "white",
                        fontSize: "11px",
                        padding: "4px 8px",
                        marginLeft: "10px",
                      }}
                    >
                      {feedback.unread_count}
                    </span>
                  ) : null}
                  <div className="text-muted small d-flex align-items-center">
                    <span>
                      {feedback.createdAt
                        ? (() => {
                            const date = new Date(feedback.createdAt);
                            if (isNaN(date)) return "-";

                            const day = date.getDate();
                            const month = date.toLocaleString("en-GB", {
                              month: "short",
                            });
                            const year = date.getFullYear();

                            let hours = date.getHours();
                            const minutes = date
                              .getMinutes()
                              .toString()
                              .padStart(2, "0");
                            const ampm = hours >= 12 ? "pm" : "am";
                            hours = hours % 12 || 12; // convert 0 → 12, 13→1 etc.

                            return `${day} ${month} ${year}, ${hours}:${minutes}${ampm}`;
                          })()
                        : "-"}
                    </span>
                  </div>
                </td>
                <td style={{ width: "80px" }}>
                  <div className="d-flex flex-column align-items-center">
                    {feedback.documents && feedback.documents.length > 0
                      ? feedback.documents.map((doc, idx) => (
                          <div
                            key={idx}
                            className="mb-2 d-flex align-items-center"
                          >
                            <a
                              href={`${
                                process.env.REACT_APP_SERVER_URL || ""
                              }/${doc.url}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="d-flex align-items-center"
                            >
                              <img
                                src={docImg}
                                alt="Document Icon"
                                className="me-2"
                                style={{ width: "32px", height: "32px" }}
                              />
                            </a>
                          </div>
                        ))
                      : null}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="text-center text-muted py-4">
                {t("No records found")}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default FeedbackLogs;
